import { CSSProperties } from 'react';

export type ElementHighlighterConfig = {
  borderColor: CSSProperties['color'];
  boxShadowColor: CSSProperties['color'];
  className?: string;
};

// TODO: Import this from color scheme when that becomes possible.
export const DEFAULT_CONFIG: ElementHighlighterConfig = {
  borderColor: '#F8598B',
  boxShadowColor: '#438EE1',
};
